import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class NotificationDetailService {

    private uri = 'plan/api/notification-detail';

    
    constructor(private httpClient: HttpClient) { }


    query(guid: any) {
        return this.httpClient.get(this.uri + '/query', { params: { guid } });
    }


}
